module.exports = __webpack_public_path__ + "img/party-emblem.d34fa23b.png";